// Tracks which LowStockAlert ids the admin has already looked at (visited
// the Alertes de stock bas page), independent of per-alert acknowledgment.
// Lets the sidebar badge reset to 0 on view while still lighting back up
// as soon as a genuinely new alert opens. Stored per employee account on the
// server (see seenNotifications.js), not in the browser.
import { fetchSeenIds, postSeenIds } from "./seenNotifications";

const KIND = "low_stock_alert";
const LEGACY_STORAGE_KEY = "outex_seen_low_stock_alert_ids";

export const LOW_STOCK_ALERTS_SEEN_EVENT = "lowStockAlertsSeenChanged";

export const getSeenAlertIds = () => fetchSeenIds(KIND, LEGACY_STORAGE_KEY);

export const markAlertsSeen = async (ids = []) => {
  if (!ids.length) return;

  try {
    await postSeenIds(KIND, ids);
  } catch (err) {
    // Badge just won't reset this time, non-fatal
    console.error("Could not save seen low-stock alerts:", err);
    return;
  }

  // Lets the sidebar badge refresh immediately while still on the alerts
  // page, instead of waiting for its next poll or a route change.
  window.dispatchEvent(new Event(LOW_STOCK_ALERTS_SEEN_EVENT));
};
